import Seo from '../components/Seo';

export default function PoliticaPrivacidad() {
  return (
    <>
      <Seo
        title="Política de Privacidad"
        description="Política de Privacidad de barcabrero.com conforme al Reglamento (UE) 2016/679 (RGPD) y la Ley Orgánica 3/2018 (LOPDGDD). Tratamiento de datos por Rumoroso56 S.L."
        path="/politica-privacidad"
      />
      <article className="sec legal-page" data-testid="politica-privacidad">
        <p className="eyebrow rv">Datos personales</p>
        <h1 className="D D-lg rv" style={{ marginBottom: '1.5rem' }}>Política de Privacidad</h1>
        <p className="lead rv" style={{ marginBottom: '2.5rem' }}>
          La presente Política regula el tratamiento de los datos personales recogidos a través del sitio web <em>barcabrero.com</em>, conforme al Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo (RGPD) y la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y Garantía de los Derechos Digitales (LOPDGDD).
        </p>

        <div className="legal-body rv">
          <h2>1. Responsable del tratamiento</h2>
          <dl className="legal-dl">
            <dt>Responsable</dt><dd>Rumoroso56, S.L. (Bar Cabrero)</dd>
            <dt>CIF</dt><dd>B-39598716</dd>
            <dt>Dirección</dt><dd>C/ Pedro Lorenzo Molleda 3, bajo · 39300 Torrelavega · Cantabria</dd>
            <dt>Teléfono</dt><dd><a href="tel:+34654233407">+34 654 23 34 07</a></dd>
            <dt>Email para gestiones RGPD</dt><dd><a href="mailto:info@barcabrero.com">info@barcabrero.com</a></dd>
          </dl>

          <h2>2. Datos que tratamos y finalidades</h2>
          <p>El sitio web no dispone de formulario de registro, cuenta de usuario ni pasarela de pago. Los datos personales que pueden tratarse son los siguientes:</p>
          <ul className="legal-list">
            <li>
              <strong>Datos de contacto facilitados voluntariamente por WhatsApp, email o teléfono:</strong> nombre, número de teléfono y contenido del mensaje. Finalidad: atender consultas, gestionar pedidos para llevar y catering. <em>Base jurídica: ejecución de una relación precontractual o contractual a solicitud del interesado (art. 6.1.b RGPD).</em>
            </li>
            <li>
              <strong>Datos de navegación y analítica</strong> (dirección IP truncada, identificador de sesión, páginas visitadas, dispositivo, navegador, tiempo en página) recogidos mediante cookies analíticas <em>únicamente si el usuario ha prestado su consentimiento</em> a través del banner de cookies. Finalidad: medir el uso del sitio y mejorar la experiencia. <em>Base jurídica: consentimiento del interesado (art. 6.1.a RGPD).</em>
            </li>
          </ul>
          <p>
            No tratamos datos especialmente protegidos (salud, ideología, religión, orientación sexual, etc.) ni datos de menores de 14 años a través del sitio.
          </p>

          <h2>3. Plazo de conservación</h2>
          <ul className="legal-list">
            <li><strong>Datos de contacto por WhatsApp/email:</strong> mientras dure la relación con el cliente y, posteriormente, durante los plazos legales aplicables (mercantil 6 años, fiscal 4 años).</li>
            <li><strong>Datos analíticos:</strong> hasta 12 meses desde la recogida o hasta que el usuario revoque su consentimiento, lo que ocurra antes.</li>
          </ul>

          <h2>4. Destinatarios y transferencias internacionales</h2>
          <p>Los datos podrán comunicarse a los siguientes encargados del tratamiento, con los que existen contratos conforme al art. 28 RGPD:</p>
          <ul className="legal-list">
            <li><strong>Proveedor de hosting</strong> (alojamiento del sitio web) — ubicado en la Unión Europea o con garantías equivalentes.</li>
            <li><strong>PostHog Inc.</strong> (analítica web) — Estados Unidos. Transferencia amparada por las Cláusulas Contractuales Tipo aprobadas por la Comisión Europea. El tratamiento solo se realiza si el usuario consiente las cookies analíticas.</li>
            <li><strong>WhatsApp / Meta Platforms Ireland</strong> — cuando el usuario decide contactarnos por esta vía, sus datos quedan sujetos a la política de privacidad de Meta.</li>
          </ul>
          <p>No se realizan transferencias internacionales fuera de los supuestos anteriores ni se aplican decisiones automatizadas con efectos jurídicos sobre las personas.</p>

          <h2>5. Derechos del interesado</h2>
          <p>El usuario puede ejercer en cualquier momento los siguientes derechos:</p>
          <ul className="legal-list">
            <li><strong>Acceso:</strong> conocer qué datos tratamos sobre usted.</li>
            <li><strong>Rectificación:</strong> corregir datos inexactos o incompletos.</li>
            <li><strong>Supresión ("derecho al olvido"):</strong> solicitar la eliminación de sus datos.</li>
            <li><strong>Oposición:</strong> oponerse al tratamiento por motivos personales.</li>
            <li><strong>Limitación del tratamiento</strong> en los supuestos previstos por la normativa.</li>
            <li><strong>Portabilidad:</strong> recibir sus datos en un formato estructurado y de uso común.</li>
            <li><strong>Revocación del consentimiento</strong> prestado para finalidades concretas (p. ej., cookies analíticas), sin que ello afecte a la licitud del tratamiento previo.</li>
          </ul>
          <p>
            Para ejercer cualquiera de estos derechos, envíe un email a <a href="mailto:info@barcabrero.com">info@barcabrero.com</a> indicando el derecho que ejerce y adjuntando una copia de su DNI o documento equivalente. Le responderemos en el plazo máximo de un mes desde la recepción de la solicitud.
          </p>
          <p>
            Asimismo, si considera que sus derechos no han sido debidamente atendidos, puede presentar una reclamación ante la <strong>Agencia Española de Protección de Datos</strong> (AEPD), C/ Jorge Juan 6, 28001 Madrid · <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer">www.aepd.es</a>.
          </p>

          <h2>6. Medidas de seguridad</h2>
          <p>
            Rumoroso56 S.L. aplica las medidas técnicas y organizativas apropiadas para garantizar la seguridad de los datos personales tratados, evitando su alteración, pérdida, tratamiento o acceso no autorizados, teniendo en cuenta el estado de la técnica, la naturaleza, el alcance y los fines del tratamiento, así como los riesgos de probabilidad y gravedad variables para los derechos y libertades de las personas.
          </p>

          <h2>7. Modificaciones</h2>
          <p>
            La presente Política puede ser revisada y actualizada para adaptarla a cambios normativos o a la introducción de nuevos tratamientos. Cualquier modificación se publicará en esta página.
          </p>

          <p className="legal-updated">Última actualización: 6 de febrero de 2026.</p>
        </div>
      </article>
    </>
  );
}
